import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "native-auth" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "text" }
const _hoisted_4 = {
  key: 0,
  class: "error"
}
const _hoisted_5 = {
  key: 1,
  class: "info"
}
const _hoisted_6 = { class: "buttons" }
const _hoisted_7 = { class: "footer" }
const _hoisted_8 = {
  key: 0,
  class: "admin-text"
}

import { ref, onMounted, onBeforeUnmount } from 'vue';

import NcButton from '@nextcloud/vue/components/NcButton';
import XImg from '@components/frame/XImg.vue';
import * as nativex from '@native';

import { setConfig } from '@services/user-config';

import axios from '@nextcloud/axios';

import banner from '@assets/banner.svg';

import { isAdmin } from '@services/utils/auth';
import { chooseNcFolder } from '@services/utils/dialog';
import { API } from '@services/API';
import { t, n } from '@services/l10n';

import type { IDay } from '@typings';


export default /*@__PURE__*/_defineComponent({
  __name: 'FirstStart',
  setup(__props) {

const error = ref('');
const info = ref('');
const show = ref(false);
const chosenPath = ref('');

async function begin() {
  let path: string;
  try {
    path = await chooseNcFolder(t('memories', 'Choose the root of your timeline'));
  } catch (e) {
    console.warn('chooseNcFolder cancelled', e);
    return;
  }

  // Get folder days
  error.value = '';
  info.value = '';
  let data: IDay[];
  try {
    const url = API.Q(API.DAYS(), { folder: path, recursive: 1 });
    const res = await axios.get<IDay[]>(url);

    // Check response
    if (res.status !== 200) {
      throw new Error(`Unexpected response code ${res.status}`);
    }

    data = res.data;
  } catch (e) {
    console.error(e);
    error.value = t('memories', 'The selected folder does not seem to be valid. Try again.');
    return;
  }

  // Count total photos
  const count = data.reduce((acc, day) => acc + day.count, 0);
  info.value = n('memories', 'Found {n} item in {path}', 'Found {n} items in {path}', count, {
    n: count,
    path,
  });
  chosenPath.value = path;

  // Check if nothing was found
  if (count === 0) {
    error.value =
      t('memories', 'No photos were found in the selected folder.') +
      '\n' +
      t('memories', 'This can happen because your media is still indexing.');

    if (isAdmin) {
      error.value += '\n\n' + t('memories', 'Visit the admin panel to make sure Memories is configured correctly.');
    }
    return;
  }
}

async function finish() {
  show.value = false;
  await new Promise((resolve) => setTimeout(resolve, 500));
  await setConfig('timeline_path', chosenPath.value);
}

onMounted(() => {
  nativex.setTheme('#174a7d', true);
  document.getElementById('content')?.classList.add('no-margins');
  window.setTimeout(() => {
    show.value = true;
  }, 300);
});

onBeforeUnmount(() => {
  nativex.setTheme(); // restore server theme
  document.getElementById('content')?.classList.remove('no-margins');
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["card outer", { show: show.value }])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(XImg, {
          class: "img",
          src: _unref(banner),
          "svg-tag": true
        }, null, 8, ["src"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createTextVNode(_toDisplayString(_unref(t)('memories', 'A better photos experience awaits you')) + " ", 1),
        _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1)),
        _createTextVNode(" " + _toDisplayString(_unref(t)('memories', 'Choose the root folder of your timeline to begin')), 1)
      ]),
      (error.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(error.value), 1))
        : _createCommentVNode("", true),
      (info.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createTextVNode(_toDisplayString(info.value) + " ", 1),
            _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1)),
            _createVNode(_unref(NcButton), {
              onClick: finish,
              class: "button",
              variant: "primary"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('memories', 'Continue to Memories')), 1)
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_6, [
        (info.value)
          ? (_openBlock(), _createBlock(_unref(NcButton), {
              key: 0,
              onClick: begin,
              class: "button"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('memories', 'Choose again')), 1)
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_unref(NcButton), {
              key: 1,
              onClick: begin,
              class: "button",
              variant: "primary"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('memories', 'Click here to start')), 1)
              ]),
              _: 1
            }))
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createTextVNode(_toDisplayString(_unref(t)('memories', 'You can always change this later in settings')) + " ", 1),
        (_unref(isAdmin))
          ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
              _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1)),
              _createTextVNode(" " + _toDisplayString(_unref(t)('memories', 'If you just installed Memories, visit the admin panel first.')), 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ], 2)
  ]))
}
}

})